export const Bindings = {
	WidgetLoaderController: Symbol("WidgetLoaderController"),
	BootstrapController: Symbol("BootstrapController"),
	JSONProvider: Symbol("JSONProvider"),
	CountryProvider: Symbol("CountryProvider"),
	JsonHTTPClient: Symbol("JsonHTTPClient"),
	ApiHTTPClient: Symbol("ApiHTTPClient"),
	RoundsStore: Symbol("RoundsStore"),
	ChecksumsStore: Symbol("ChecksumsStore"),
	SquadsStore: Symbol("SquadsStore"),
	SquadImageController: Symbol("SquadImageController"),
	WidgetController: Symbol("WidgetController"),
	FiltersController: Symbol("FiltersController"),
	MatchCardController: Symbol("MatchCardController"),
	MatchStatusController: Symbol("MatchStatusController"),
	HOCLiveScoreController: Symbol("HOCLiveScoreController"),
	LocalizationStore: Symbol("LocalizationStore"),
	CountryStore: Symbol("CountryStore"),
	LocalizationController: Symbol("LocalizationController"),
	BettingPartnerController: Symbol("BettingPartnerController"),
	OddsController: Symbol("OddsController"),
};
